module.exports = __webpack_public_path__ + "img/google_icon.70f0d980.svg";